// extracted by mini-css-extract-plugin
export default {"paye-header":"Header_paye-header__MZf-B","paye-header__buttons":"Header_paye-header__buttons__lnep0"};